<template>
  <v-container>
    <v-row class="mt-1 mb-1 mr-1 d-flex justify-end" v-if="!usePaymentStore().noResults">
      <v-btn class="my-0" color="primary" prepend-icon="mdi-plus" @click="createPayment()">
        {{ $t("common.action.createPayment") }}
      </v-btn>
    </v-row>
    <payment-list-card
  /></v-container>
</template>
<script lang="ts" setup>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import PaymentListCard from "@/payments/components/payment/PaymentListCard.vue";
import { usePaymentStore } from "@/payments/stores/payments";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

onMounted(async () => {
  usePaymentStore().setFilterPaymentCondition({});
  await usePaymentStore().getFilteredPayments();
});

const createPayment = () => {
  router.push({ name: "createPayment" });
};
</script>
